<div *ngIf="state.androidProcessDetails && state.androidProcessDetails.applications.length > 0">
    <div class="back" (click)="goBack()">
            <a>
                <span class="hd-icon icon-sm hd-icon-arrow"></span>
                <span class="selectedTask-name">{{state.selectedTask.name}}</span>
            </a>
    </div>

    <div class = "task-details" fill fill-padding="25">
        <div class="task-details-panel fill scroll">

            <!-- Memory Table -->
            <div class="task-details-property task-details-flextable-container">
                <div class="task-details-title">
                    <div class="task-details-table-title">{{'taskAndroidDetails_memUsage' | xsI18n }}</div>
                </div>
                <div class="task-details-flextable scroll" >
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell heading-cell-usage-errorstate-table cell-left">
                            {{'taskAndroidDetails_usageType' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell heading-cell-usage-errorstate-table cell-right fill">
                            {{'taskAndroidDetails_memUsed' | xsI18n }}
                        </div>
                    </div>
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell cell-left">
                                {{'taskAndroidDetails_dalvikVM' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell hex-font cell-right fill">
                                {{state.androidProcessDetails.memoryUsage.dalvikVM}}
                        </div>
                    </div>
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell cell-left">
                                {{'taskAndroidDetails_native' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell hex-font cell-right fill">
                                {{state.androidProcessDetails.memoryUsage.native}}
                        </div>
                    </div>
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell  cell-left">
                                {{'taskAndroidDetails_other' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell hex-font cell-right fill">
                                {{state.androidProcessDetails.memoryUsage.other}}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Error Info Table -->
            <div class="task-details-property task-details-flextable-container">
                <div class="task-details-title">
                    <div class="task-details-table-title">{{'taskAndroidDetails_errorInfo' | xsI18n }}</div>
                </div>
                <div class="task-details-flextable scroll" >
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell heading-cell-usage-errorstate-table cell-left">
                            {{'xs_name_label' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell heading-cell-usage-errorstate-table cell-right fill">
                            {{'taskAndroidDetails_value' | xsI18n }}
                        </div>
                    </div>
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell cell-left">
                                {{'taskAndroidDetails_condition' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell hex-font cell-right fill">
                                {{state.androidProcessDetails.errorStateInfo.condition}}
                        </div>
                    </div>
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell cell-left">
                                {{'taskAndroidDetails_conditionMsg' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell cell-right hex-font ellipsis fill" hd-ellipsis-text>
                            {{state.androidProcessDetails.errorStateInfo.conditionMessage}}
                        </div>
                    </div>
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell cell-left">
                                {{'taskAndroidDetails_cause' | xsI18n }}
                        </div>
                        <div class="task-details-flextable-cell cell-right hex-font ellipsis fill" hd-ellipsis-text>
                            {{state.androidProcessDetails.errorStateInfo.cause}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="task-details-property task-details-flextable-container">
                <div class="task-details-title">
                    <div class="task-details-table-title">{{'taskAndroidDetails_application' | xsI18n }}</div>
                </div>
                <div class="task-details-flextable scroll" >
                    <div class="task-details-flextable-row bottom-border">
                        <div class="task-details-flextable-cell heading-cell fill" (click)="sortPackageTableBy('name')">
                            {{'taskAndroidDetails_applicationPkg' | xsI18n }}
                            <span *ngIf="androidPackageTableSort.column === 'name'" class="hd-icon icon-sm" [ngClass]="androidPackageTableSort.reverse?'hd-icon-sortdown':'hd-icon-sortup'"></span>
                        </div>
                    </div>
                    <div class="task-details-flextable-row maxWidth bottom-border" *ngFor="let package of state.androidProcessDetails.applications">
                        <div class="task-details-flextable-cell ellipsis hex-font fill" hd-ellipsis-text>
                            {{package.name}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="detailNotAvailable" *ngIf="state.androidProcessDetails && state.androidProcessDetails.applications.length <= 0" fill>
    <img class="NotFound" src="'get-resource/images/NotFound.svg'"/>
    <div>{{'taskDetails_unavailable' | xsI18n }}</div>
    <hr class="hr">
    <div class = "back-btn btn-lg" (click)="goBack()">
        <a>
            <span class="hd-icon icon-md hd-icon-chevron-left">{{'taskDetails_back' | xsI18n }}></span>
        </a>
    </div>
</div>
